<template>
  <div class="h-screen">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const config = useRuntimeConfig();

useHead(() => ({
  title: t('head.title'),
  meta: [
    {
      hid: 'description',
      name: 'description',
      content: t('head.description'),
    },
  ],
  link: [
    {
      rel: 'dns-prefetch',
      href: 'https://www.googletagmanager.com',
    },
    {
      hid: 'icon',
      rel: 'icon',
      type: 'image/svg+xml',
      href: `/brand/${config.public.brand}/favicon.png`,
    },
  ],
}));
</script>

<script lang="ts">
export default defineComponent({
  name: 'PlainLayout',
});
</script>
